import { DivineControlEvent } from "../../../DivineControlEventBase.js";
export class DCBaseGamepadButtonEvent extends DivineControlEvent {
    eventType = "gamepad-botton-down";
    inputType = "gamepad-button";
    constructor() {
        super();
    }
    getButton() {
        return this.getData().button;
    }
}
